import { app } from '../../../../bootstrap/core';
import { passwordFormComponent } from './passwordForm.component';

app.component('passwordForm', passwordFormComponent);
